// GrabMillet CRM Constants
export const APARTMENTS = ['Aspire Heights', 'Amara Courtyard', 'JRM Pearl', 'Other'];

export const LEAD_SOURCES = [
  'Meta Ads',
  'Google Ads',
  'Tasting events',
  'Banner',
  'Apartment WhatsApp Groups',
  'Word of Mouth',
  'Referral',
  'Pamphlet/flyer',
  'D2D visit'
];

export const CALL_STATUSES = [
  'Called - answered',
  'Called - no answer',
  'WhatsApp sent',
  'Visited in person',
  'Tasting event'
];

export const ORDER_STATUSES = [
  'New',
  'Interested',
  'Callback - next week',
  'Callback - next month',
  'Callback - specific date',
  'Converted',
  'Lost / not interested'
];

export const PIPELINE_STAGES = ['New', 'Interested', 'Callback', 'Converted', 'Lost'];

export const DELIVERY_SLOTS = [
  '6:00-6:30 AM',
  '6:30-7:00 AM',
  '7:00-7:30 AM',
  '7:30-8:00 AM',
  '8:00-8:30 AM'
];

export const PLANS = [
  { value: 1499, label: '1,499 / month (All Days)', deliveryDays: [0, 1, 2, 3, 4], totalDeliveries: 22, duration: 'monthly' },
  { value: 999, label: '999 / month (Alternate Days)', deliveryDays: [0, 2, 4], totalDeliveries: 12, duration: 'monthly' },
  { value: 349, label: '349 / week', deliveryDays: [0, 1, 2, 3, 4], totalDeliveries: 5, duration: 'weekly' }
];

export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const SUBSCRIBER_STATUSES = ['active', 'paused', 'inactive', 'out-of-town'];

export const LANGUAGES = ['Telugu', 'Kannada', 'Tamil', 'Hindi', 'English', 'Malayalam'];

export const ITEMS = [
  'Ragi Ambali',
  'Ragi Banana Milkshake',
  'Foxtail Millet Rice',
  'Ragi Muffin Cake',
  'Mixed Millet Dosa Batter',
  'Peanut Powder'
];

export const SKIP_REASONS = [
  'Customer request',
  'Out of town',
  'Festival / holiday',
  'Medical / health',
  'Other'
];

export const PAYMENT_MODES = ['UPI / GPay', 'Cash', 'Bank transfer'];

export const getStatusBadgeClass = (status) => {
  const s = (status || '').toLowerCase();
  if (s.includes('new')) return 'badge-new';
  if (s.includes('interested')) return 'badge-interested';
  if (s.includes('callback')) return 'badge-callback';
  if (s.includes('converted')) return 'badge-converted';
  if (s.includes('lost')) return 'badge-lost';
  if (s === 'active') return 'badge-active';
  if (s === 'paused') return 'badge-paused';
  if (s === 'inactive') return 'badge-inactive';
  if (s === 'out-of-town') return 'badge-oot';
  if (s === 'delivered') return 'badge-delivered';
  if (s === 'pending') return 'badge-pending';
  if (s === 'skipped') return 'badge-skipped';
  return 'badge-new';
};
